import { createStoreModule } from '../utils';
export default createStoreModule({
  name: 'domain',
  modelName: 'custom_domains',
  crud: true,
  endpoint: '/v2/custom_domains'
});
